module.exports = __webpack_public_path__ + "static/img/cp_3.c6f67ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/cp_3.png
// module id = 8+De
// module chunks = 1